import actions from '@/store/modules/log/logCommonState/log.actions';
import mutations from '@/store/modules/log/logCommonState/log.mutation';
import getters from '@/store/modules/log/logCommonState/log.getters';
import {
  addWidgetDefulatData,
  executeSavedSearchDefaultData
} from '@/components/Log/log.types';
import { TranslateResult } from 'vue-i18n'
import _ from 'lodash';

export interface MultiSelectFieldOption {
  label: string;
  key: string;
  selected: boolean;
}

interface RexSearchSelectItem {
  name: TranslateResult | string;
  id: string;
}

export interface SavedSearchInfo {
  savedSearchName: string;
  query: string;
}

export interface AddDashboardInfo {
  widgetName: string;
  dashboardName: string;
  dashboard: RexSearchSelectItem;
  widgetType: string;
}

interface WidgetFormData {
  isNewDash: boolean;
  isLoading: boolean;
  isQueryValid: boolean;
  isSavedSearchValid: boolean;
  isWidgetNameValid: boolean;
  isDashNameValid: boolean;
  isDashboardValid: boolean;
  isCreateOrUpdateSavedSearch: boolean;
  isQueryExecuted: boolean;
}

export interface AddWidgetData {
  savedSearchInfo: SavedSearchInfo;
  addDashboardInfo: AddDashboardInfo;
  widgetFormData: WidgetFormData;
}

interface ExecuteSavedSearch {
  isAddWidgetWithoutSavedSearch: boolean;
  savedSearchName: string;
  service_id: string;
  isTextSearchTypeSelected: boolean;
  queryMetric: string;
}

export interface State {
  queryDataLoading: boolean;
  queryHeaders: Array<object>;
  sourceList: Array<object>;
  freeSearchSources: Array<MultiSelectFieldOption>;
  queryEnableSavedSearchType: string;
  reloadGrokTable: boolean;
  reloadSavedSearchTable: boolean;
  addWidgetData: AddWidgetData;
  executeSavedSearch: ExecuteSavedSearch;
  isADType: Boolean;
  anlyInfoFieldsList: Array<Object>;
  logInfoFieldsList: Array<Object>;
  tagLoading: Boolean;
  isSearchListEmpty: Boolean;
  sourceCurrentPage: Number;
}

export const initialState: State = {
  queryDataLoading: true,
  queryHeaders: [],
  sourceList: [],
  freeSearchSources: [],
  queryEnableSavedSearchType: '',
  reloadGrokTable: false,
  reloadSavedSearchTable: false,
  addWidgetData: _.cloneDeep(addWidgetDefulatData),
  executeSavedSearch: _.cloneDeep(executeSavedSearchDefaultData),
  isADType: false,
  anlyInfoFieldsList: [],
  logInfoFieldsList: [],
  tagLoading: false,
  isSearchListEmpty: false,
  sourceCurrentPage: 1,
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
